import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import Banner1 from '../../images/electricpower2.jpg';
import PortImage10 from '../../images/electric1.jpg';
import PortImage11 from '../../images/automation2.jpg';
import PortImage12 from '../../images/automation3.png';
import ClientLogo1 from '../elements/client-logo/client-logo-1';

class Electrical extends Component {

    render(){
        return (
            <>
           <Header1 />

<div className="page-content bg-white">

    <div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
        <div className="container">
            <div className="page-banner-entry">
                <h1 className="text-white">Electrical, Power & Automation Services</h1>
                <div className="breadcrumb-row">
                    <ul className="list-inline">
                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                        <li>Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="content-block" id="content-area">
        
        {/* Electrical & Power Engineering */}
        <div className="section-area section-sp2 port-7-content">
            <div className="container">
                <div className="row">

                    <div className="col-lg-7">
                        <div className="heading-bx text-left m-b20">
                            <h3 className="title-head m-b0">Electrical & Power Engineering Services</h3>
                            <div className="ttr-separator sepimg"></div>
                        </div>

                        <h5>Engineering & Power Infrastructure</h5>
                        <p>
                            GO-PS provides end-to-end electrical and power engineering services for industrial, energy, and Oil & Gas facilities, covering the full lifecycle from studies and engineering to installation, commissioning, and operational support.
                        </p>

                        <h5>Distribution Networks & Substations</h5>
                        <p>
                            Our expertise includes medium and low voltage (MV/LV) distribution networks, electrical substations, switchgear, transformers, protection relays, and grounding systems, all designed in compliance with international standards and local regulations.
                        </p>

                        <h5>Power System Studies & Safety Analysis</h5>
                        <p>
                            We perform detailed power system studies including load flow analysis, short-circuit calculations, protection selectivity, and arc-flash assessments to ensure safe, reliable, and optimized electrical networks.
                        </p>

                        <h5>Backup Power & Continuity Solutions</h5>
                        <p>
                            GO-PS delivers backup and emergency power solutions using generators, UPS systems, and redundancy architectures to secure critical operations and maintain continuity under all operating conditions.
                        </p>

                        <h5>Modernization, Efficiency & Compliance</h5>
                        <p>
                            Our services extend to electrical rehabilitation, modernization, and compliance upgrades, with a strong focus on power quality improvement, energy efficiency enhancement, and technical loss reduction to maximize asset performance.
                        </p>
                    </div>

                    <div className="col-lg-5">
                        <div className="row sp4 magnific-image sticky-top">
                            <div className="action-card col-lg-12 wow fadeInUp">
                                <div className="portfolio-box">
                                    <div className="portfolio-media">
                                        <img src={PortImage10} alt="" style={{ border: "6px solid #ff6600" }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        {/* Automation, SCADA & Digital Energy */}
        <div className="section-area section-sp2 port-7-content bg-light">
            <div className="container">
                <div className="row">

                    <div className="col-lg-7">
                        <div className="heading-bx text-left m-b20">
                            <h3 className="title-head m-b0">Automation, SCADA & Digital Energy</h3>
                            <div className="ttr-separator sepimg"></div>
                        </div>

                        <h5>Automation & Control Systems</h5>
                        <p>
                            GO-PS integrates advanced automation and control systems to enable reliable, flexible, and safe operation of electrical and industrial assets.
                        </p>

                        <h5>SCADA, EMS & DMS Platforms</h5>
                        <p>
                            We deploy SCADA, Energy Management Systems (EMS), and Distribution Management Systems (DMS) to provide real-time monitoring, centralized control, and optimized decision-making.
                        </p>

                        <h5>Substation & Process Automation</h5>
                        <p>
                            Our solutions include substation automation systems (SAS/SCS), PLC, RTU, and HMI-based architectures adapted to complex industrial and utility environments.
                        </p>

                        <h5>Industrial Communication & Cybersecurity</h5>
                        <p>
                            We design secure industrial communication networks using fiber-optic and wireless technologies, ensuring high availability, data integrity, and cybersecurity compliance.
                        </p>

                        <h5>Digital Energy & System Integration</h5>
                        <p>
                            GO-PS ensures seamless integration with existing Oil & Gas control systems and enterprise platforms, enabling predictive maintenance, energy optimization, and smarter, more resilient power infrastructures.
                        </p>
                    </div>

                    <div className="col-lg-5">
                        <div className="row sp4 magnific-image sticky-top">
                            <div className="action-card col-lg-12 wow fadeInUp">
                                <div className="portfolio-box">
                                    <div className="portfolio-media">
                                        <img src={PortImage11} alt="" style={{ border: "6px solid #ff6600" }}/>
                                    </div>
                                    <div className="portfolio-media" style={{marginTop:16}}>
                                        <img src={PortImage12} alt="" style={{ border: "6px solid #ff6600" }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    {/* Partners */}
    <div className="section-area section-sp2 bg-gray">
        <div className="container wow fadeIn" data-wow-delay="0.8s">
            <div className="heading-bx text-center">
                <h6 className="title-ext m-b0">Our Partner</h6>
                <h2 className="title-head m-b0">Partners & Clients</h2>
                <div className="ttr-separator sepimg"></div>
            </div>
            
            <ClientLogo1 />
    
        </div>
    </div>

</div>

<Footer1 />


</>
        );
    }
}

export default Electrical;
